import { SubjectMenuList } from '@models/types/students.type';
import moment from 'moment';
import { convertToSlug } from './convertToSlug';
import { ISubjectSubscription } from '@models/interfaces/user.interface';
import { IExpSubsDate } from '@models/interfaces/local_storage.interface';

function getLocalTimeMoment(dateTime: string) {
  const dateMoment = moment(dateTime);

  // for detecting timezone offset https://stackoverflow.com/a/8090836
  const timezone = parseInt(
    (-(new Date().getTimezoneOffset() / 60)).toString(),
  );
  dateMoment.hour(dateMoment.hour() - 8 + timezone);

  return dateMoment;
}

function getLocalTimeString(dateTime: string) {
  return getLocalTimeMoment(dateTime).format('YYYY-MM-DD HH:mm:ss');
}

export function getDelayedStartDate(
  subjectSlug: string,
  subjectMenuArr: SubjectMenuList[],
  subjectSubscriptionArr: ISubjectSubscription[],
) {
  const selectedSubjectSubscription = getSelectedSubscription(
    subjectSlug,
    subjectMenuArr,
    subjectSubscriptionArr,
  );
  return selectedSubjectSubscription &&
    selectedSubjectSubscription.delayed_start_date
    ? getLocalTimeString(selectedSubjectSubscription.delayed_start_date)
    : '';
}

export function getExpiryDate(
  subjectSlug: string,
  subjectMenuArr: SubjectMenuList[],
  subjectSubscriptionArr: ISubjectSubscription[],
) {
  const selectedSubjectSubscription = getSelectedSubscription(
    subjectSlug,
    subjectMenuArr,
    subjectSubscriptionArr,
  );
  return selectedSubjectSubscription && selectedSubjectSubscription.expiry_date
    ? getLocalTimeMoment(selectedSubjectSubscription.expiry_date).format(
        'YYYY-MM-DD HH:mm:ss',
      )
    : '';
}

export function getSelectedSubscription(
  subjectSlug: string,
  subjectMenuArr: SubjectMenuList[],
  subjectSubscriptionArr: ISubjectSubscription[],
) {
  if (
    !!subjectSlug &&
    Array.isArray(subjectMenuArr) &&
    Array.isArray(subjectSubscriptionArr)
  ) {
    for (let i = 0; i < subjectMenuArr.length; i++) {
      if (convertToSlug(subjectMenuArr[i].display_name) == subjectSlug) {
        for (let j = 0; j < subjectSubscriptionArr.length; j++) {
          if (
            parseInt(subjectMenuArr[i].subject_id) ==
            subjectSubscriptionArr[j].subject_id
          )
            return subjectSubscriptionArr[j];
        }
      }
    }
  }
  return false;
}

export function isSubscriptionDelayed(
  subjectSlug: string,
  subjectMenuArr: SubjectMenuList[],
  subjectSubscriptionArr: ISubjectSubscription[],
) {
  const selectedSubjectSubscription = getSelectedSubscription(
    subjectSlug,
    subjectMenuArr,
    subjectSubscriptionArr,
  );

  return (
    selectedSubjectSubscription &&
    selectedSubjectSubscription.delayed_start_date &&
    getLocalTimeMoment(
      selectedSubjectSubscription.delayed_start_date,
    ).valueOf() > moment().valueOf()
  );
}

export function isSubscriptionExpired(
  subjectSlug: string,
  subjectMenuArr: SubjectMenuList[],
  subjectSubscriptionArr: ISubjectSubscription[],
) {
  const selectedSubjectSubscription = getSelectedSubscription(
    subjectSlug,
    subjectMenuArr,
    subjectSubscriptionArr,
  );

  return (
    selectedSubjectSubscription &&
    selectedSubjectSubscription.expiry_date &&
    getLocalTimeMoment(selectedSubjectSubscription.expiry_date)
      .add(selectedSubjectSubscription.subscription_grace_period, 'day')
      .valueOf() < moment().valueOf()
  );
}

export function isSubscriptionExpiredFromLS(subjectSlug: string) {
  const tmpLocalStorageExpSubs: IExpSubsDate = JSON.parse(
    localStorage.getItem('exp_subs_date') ?? '{}',
  );
  return (
    moment(tmpLocalStorageExpSubs[subjectSlug]).valueOf() < moment().valueOf()
  );
}

export function isSubscriptionTrial(
  subjectSlug: string,
  subjectMenuArr: SubjectMenuList[],
  subjectSubscriptionArr: ISubjectSubscription[],
) {
  const selectedSubjectSubscription = getSelectedSubscription(
    subjectSlug,
    subjectMenuArr,
    subjectSubscriptionArr,
  );
  return (
    selectedSubjectSubscription && selectedSubjectSubscription.is_trial_plan
  );
}
